import { render } from "./features-page.vue?vue&type=template&id=fa24769c&scoped=true"
import script from "./features-page.vue?vue&type=script&lang=js"
export * from "./features-page.vue?vue&type=script&lang=js"

import "./features-page.vue?vue&type=style&index=0&id=fa24769c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa24769c"]])

export default __exports__